import { render, staticRenderFns } from "./ARData.vue?vue&type=template&id=fa9b6486"
import script from "./ARData.vue?vue&type=script&lang=js"
export * from "./ARData.vue?vue&type=script&lang=js"
import style0 from "./ARData.vue?vue&type=style&index=0&id=fa9b6486&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports